export const contactEmailAddress = "delio.support@asplanviak.no";
